import BaseServiceCrud from './BaseServiceCrud';

export default class StaticContentService extends BaseServiceCrud {
    // Initializing important variables
    constructor() {
        super();
        this.path = 'static-content';
    }

    getCriteria(criteria) {
        return this.objToQueryString({
            staticContentType: criteria.staticContentType?.enumValue,
            title: criteria.title,
            id: criteria.id,
            first_result: criteria.firstResult,
            max_result: criteria.maxResult,
            sort_field: criteria.sortField,
            sort_asc: criteria.sortAsc,
        });
    }

    getStaticContentTypes() {
        return this.fetch(`${this.domain}/${this.path}/types`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    getContent(type) {
        return this.fetch(`${this.domain}/${this.path}/content/` + type, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    getRegulations(type) {
        return this.fetch(`${this.domain}/${this.path}/content/` + type , {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
}
